// ConfirmModal.js
import React from 'react';

const ConfirmModal = ({ visible, message, onConfirm, onCancel }) => {
  if (!visible) return null;

  return (
    <div className="modal-back">
      <div className="modalcontent">
        <p dangerouslySetInnerHTML={{ __html: message }} />
        <div className="modal-actions">
          <button className="yesBtn" onClick={onConfirm}>Yes</button>
          <button  className="cancelBtn" onClick={onCancel}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
